import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

interface GetBackendAgentAddedFieldIdsOptions {
  currentFieldIds: readonly string[];
  previousFieldIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentAddedFieldIds({
  currentFieldIds,
  previousFieldIds,
  transaction
}: GetBackendAgentAddedFieldIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const previousFieldIdSet = new Set(previousFieldIds);
  return currentFieldIds.filter((fieldId) => !previousFieldIdSet.has(fieldId));
}

export function isFieldOrderingChangeAdditionOnly({
  addedFieldIds,
  currentFieldIds,
  previousFieldIds
}: {
  addedFieldIds: readonly string[];
  currentFieldIds: readonly string[];
  previousFieldIds: readonly string[];
}): boolean {
  if (addedFieldIds.length === 0) {
    return false;
  }

  const addedFieldIdSet = new Set(addedFieldIds);
  const retainedFieldIds = currentFieldIds.filter(
    (fieldId) => !addedFieldIdSet.has(fieldId)
  );

  return (
    retainedFieldIds.length === previousFieldIds.length &&
    retainedFieldIds.every((fieldId, index) => fieldId === previousFieldIds[index])
  );
}
